import {loop, Effects} from 'redux-loop';
import { FETCH_WECHAT_ARTICLE, FETCH_WECHAT_ARTICLE_SUCCESS } from './actions';
import { fetchWechatArticle } from './tasks';
const initialState = {

}

export default (state = initialState, action) => {
  if (action.type === FETCH_WECHAT_ARTICLE) {
    return loop({
      ...state,
      isLoading: true
    },
      Effects.promise(fetchWechatArticle, action.data)
    )
  }
  if (action.type === FETCH_WECHAT_ARTICLE_SUCCESS) {
    return loop({
      ...state,
      data: action.data,
      isLoading: false,
    },
      Effects.none()
    )
  }
  return loop(state, Effects.none())
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/carousel/reducer.js
 **/